const removeTrailingSlash = (value: string) => value.replace(/\/+$/, '');

const apiUrl = removeTrailingSlash(import.meta.env.VITE_API_URL ?? '');
const defaultSignalRUrl = `${apiUrl}/hubs/monitoring`;
const browserHostname = typeof window === 'undefined' ? 'localhost' : window.location.hostname;
const defaultCameraMediaUrl = import.meta.env.DEV
  ? `http://${browserHostname}:5113`
  : apiUrl;
const cameraMediaUrl = removeTrailingSlash(
  import.meta.env.VITE_CAMERA_MEDIA_URL || defaultCameraMediaUrl,
);

export const appConfig = {
  apiUrl,
  cameraMediaUrl,
  signalRUrl: import.meta.env.VITE_SIGNALR_URL || defaultSignalRUrl,
  requestTimeoutMs: 10_000,
} as const;
